import {Chip, Stack} from "@mui/material";
import ChairIcon from "@mui/icons-material/Chair";
import React from "react";

export default function MemberRegionChip({regionDetails}) {

    return <>
        <Stack direction={"row"} flexWrap={"wrap"}>
            {
                regionDetails?.sessionInfo?.regionalSeatInfo.map(entry => {
                    return <Chip key={entry.region}
                                 icon={<ChairIcon/>}
                                 label={`${entry.count} ${entry.region}`}
                                 sx={{margin: '0.125rem', padding: '0.125rem'}}/>
                })
            }
        </Stack>
    </>;
}